function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelliconWithoutDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179854"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12940",
    transform: "translate(-1224 -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 504",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1224 13)",
    style: {
      fill: "#f0f5f8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "m16.082 15.676-1.229-1.2V8.87a6.562 6.562 0 0 0-5.241-6.377V1.4a1.43 1.43 0 0 0-2.859 0v1.093A6.562 6.562 0 0 0 1.512 8.87v5.6l-1.229 1.2a.932.932 0 0 0 .667 1.6h14.455a.932.932 0 0 0 .677-1.6z",
    transform: "translate(7.523 6)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.818 1.818A1.817 1.817 0 0 0 3.636 0H0a1.817 1.817 0 0 0 1.818 1.818z",
    transform: "translate(13.887 24.182)",
    style: {
      fill: "#203662"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelliconWithoutDot);
export default __webpack_public_path__ + "static/media/belliconWithoutDot.e80b176898c44c7b70d2e7f951d6fc72.svg";
export { ForwardRef as ReactComponent };